import { createContext, useContext, useState } from "react"
import Modal from "../components/Modal";

const ModalContext = createContext(undefined);

export const useModal = () => {
    const context = useContext(ModalContext);

    if(!context){
        throw new Error('UseModal must be used within a ModelProp');
    }

    return context;
}

export const ModalProvider = ({children}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [content, setContent] = useState(null);
    const [title, setTitle] = useState(undefined);

    const openModal = (modalContent, modalTitle) => {
        setContent(modalContent);
        setTitle(modalTitle);
        setIsOpen(true);
    }

    const closeModal = () => {
        setIsOpen(false);
        setContent(null)
        setTitle(undefined);
    }

    return (
        <ModalContext.Provider value={{ openModal, closeModal, isOpen}}>
            {children}
            <Modal isOpen={isOpen} onClose={closeModal} title={title}>
                {content}
            </Modal>
        </ModalContext.Provider>
    )
}